module.exports = __webpack_public_path__ + "img/snapdeal.5b2e4ad2.png";